import {
	put,
	call,
	fork,
	takeLatest,
	takeEvery,
	all,
} from "redux-saga/effects";
import { cycleStreets, opendata, rm, wp } from "../services";
import * as actions from "../actions";

// Get journeys from CycleStreets
function* getjourneys(action) {
	try {
		const journeys = yield call(cycleStreets.getjourneys, action.options);
		yield put(actions.putjourneys(journeys));
	} catch (error) {
		yield put(actions.addError(error, "routePlanning"));
	}
}
function* watchGetjourneys() {
	yield takeLatest(actions.GET_JOURNEYS, getjourneys);
}

// Get POI from GIS
function* getPOI(action) {
	const { POIType } = action.options;

	const poi = yield call(opendata.getPOI, action.options);
	yield put(actions.putPOI(poi, POIType));
}
function* watchGetPOI() {
	yield takeEvery(actions.GET_POI, getPOI);
}

// Get parking from CycleStreets
function* getParking(action) {
	const parking = yield call(cycleStreets.getParking, action.options);
	yield put(actions.putPOI(parking, "bikeParking"));
}
function* watchGetParking() {
	yield takeEvery(actions.GET_PARKING, getParking);
}

// Get leisure rides from Bristol Open Data
function* getRides(action) {
	const rides = yield call(opendata.getRides, action.options);
	yield put(actions.putRides(rides));
}
function* watchGetRides() {
	yield takeLatest(actions.GET_RIDES, getRides);
}

// Get Cycle Hire company.
function* getCycleHire(action) {
	const { hireComp } = action.options;

	let hire = null;

	if (hireComp === "stationary") {
		hire = yield call(opendata.getCycleHireOD, action.options);
	} else {
		hire = yield call(rm.getCycleHire, action.options);
	}

	yield put(actions.putCycleHire(hire, hireComp));
}
function* watchGetCycleHire() {
	yield takeEvery(actions.GET_CYCLE_HIRE, getCycleHire);
}

// Get LCN data from Bristol Open Data
function* getLCN(action) {
	const lcn = yield call(opendata.getLCN, action.options);
	yield put(actions.putLCN(lcn));
}
function* watchGetLCN() {
	yield takeLatest(actions.GET_LCN, getLCN);
}

// Get SR data from Bristol Open Data
function* getSR(action) {
	const sr = yield call(opendata.getSR, action.options);
	yield put(actions.putSR(sr));
}
function* watchGetSR() {
	yield takeLatest(actions.GET_SR, getSR);
}

// Get SUS data from Bristol Open Data
function* getSUS(action) {
	const sus = yield call(opendata.getSUS, action.options);
	yield put(actions.putSUS(sus));
}
function* watchGetSUS() {
	yield takeLatest(actions.GET_SUS, getSUS);
}

// Get WP menu
function* getWPmenus(action) {
	try {
		const wpAPI = yield call(wp.getHeaderMenu, action.options);
		yield put(actions.putWPMenus(wpAPI));
	} catch (error) {
		yield put(actions.addError(error, "Wordpress API Error"));
	}
}
function* watchGetWPmenus() {
	yield takeLatest(actions.GET_HEADER_MENUS, getWPmenus);
}

export default function* root() {
	yield all([
		fork(watchGetjourneys),
		fork(watchGetPOI),
		fork(watchGetParking),
		fork(watchGetRides),
		fork(watchGetCycleHire),
		fork(watchGetLCN),
		fork(watchGetSR),
		fork(watchGetSUS),
		fork(watchGetWPmenus),
	]);
}



// WEBPACK FOOTER //
// ./src/sagas/index.js